import React, { useContext, useEffect, useState } from "react";
import { InstitutionalContext } from "../../context/InstitutionalContext";
import "./Institutional.css";
import { Navbar, Nav, Container } from "react-bootstrap";

const Institutional = () => {
  const { institutionals, institutionalsCategori, fetchInstitutional } = useContext(InstitutionalContext);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!selectedCategory) {
      fetchInstitutional("hakkimizda");
    }
  }, [selectedCategory]);

  const handleCategoryClick = (sef) => {
    setSelectedCategory(sef);
    fetchInstitutional(sef);
    setExpanded(false);
  };

  return (
    <div className="inst-page-wrapper">
      <Navbar expand="lg" className="inst-navbar position-relative">
        <Container className="flex-lg-column inst-header">
          <Navbar.Brand>
            {institutionals && institutionals.baslik}
          </Navbar.Brand>
          <Navbar.Toggle 
            aria-controls="institutional-nav" 
            onClick={() => setExpanded(!expanded)}
            className="position-absolute top-0 end-0 p-1 m-1"
          />
          <Navbar.Collapse id="institutional-nav" in={expanded}>
            <Nav className="flex-column w-100">
              {institutionalsCategori.map((category,id) => (
                <Nav.Link
                  key={id}
                  className={`inst-category-item ${selectedCategory === category.sef ? "active" : ""}`}
                  onClick={() => handleCategoryClick(category.sef)}
                >
                  {category.baslik}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="inst-content-section">
        {institutionals ? (
          <div>
            <h3>{institutionals.baslik}</h3>
            <div dangerouslySetInnerHTML={{ __html: institutionals.aciklama }} />
          </div>
        ) : (
          <p>İçerik yükleniyor...</p>
        )}
      </div>
    </div>
  );
};

export default Institutional;